export default __webpack_public_path__ + "static/media/provider-icon.330713ae.svg";